import api from 'Application/api/api';

const getTemplate = (id, load = [], cancelToken = null) =>
    api.get(`project-manager/templates/${id}`, {
        params: {
            load,
        },
        cancelToken,
    });

export default getTemplate;
